import { render } from "./SectionCard.vue?vue&type=template&id=6b58249c&scoped=true"
import script from "./SectionCard.vue?vue&type=script&lang=js"
export * from "./SectionCard.vue?vue&type=script&lang=js"

import "./SectionCard.vue?vue&type=style&index=0&id=6b58249c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b58249c"]])

export default __exports__